<template>
  <v-defaults-provider :defaults="defaults">
    <transition name="nav-fade">
      <component
        :is="layout"
        v-if="layout"
      >
        <router-view v-slot="{ Component, route }">
          <transition name="nav-fade">
            <!-- Div is needed to force root element for transition -->
            <div
              :key="route.path"
              class="fill-height"
            >
              <component :is="Component" />
            </div>
          </transition>
        </router-view>
      </component>
    </transition>
  </v-defaults-provider>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { capitalize } from "lodash"
import gtm from "@/mixins/gtm"

export default defineComponent({
  head() {
    return {
      titleTemplate: "%s | " + import.meta.env.VITE_APP_NAME,
      title: this.$route?.meta?.title || capitalize(this.$route?.name as string).replace('-', ' ') || undefined
    }
  },
  computed: {

    /**
     * Defaults for Vuetify components
     */
    defaults(): object {
      return {
        VTooltip: {
          openOnHover: !this.$vuetify.display.smAndDown, // force tooltips to be blocked on mobile
        },
      }
    },

    layout(): string | null{
      if (!this.$route) return null
      return this.$route.meta?.layout ? this.$route.meta.layout + "Layout" : "EmptyLayout"
    },
  },
  mixins: [gtm],

  mounted() {
    this.trackFirstLanding()
  }
})
</script>

<style lang="scss">
.nav-fade-enter-active,
.nav-fade-leave-active {
  transition: opacity 0.3s ease;
}

.nav-fade-leave-active {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}

.nav-fade-leave-to {
  opacity: 0;
}
</style>
